import { render, staticRenderFns } from "./AdminDrawer.vue?vue&type=template&id=4565600c"
import script from "./AdminDrawer.vue?vue&type=script&lang=js"
export * from "./AdminDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports